import styled from 'styled-components';
import { visibilityStyles } from '../../styled/accessibility';
import { focusStyles } from '../../styled/focus';

export const StyledLabel = styled.label`
  display: block;
  margin-bottom: 0;
  line-height: 1;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  span {
    background: ${({ theme }) => theme.palette.white};
    border: 2px solid ${({ theme }) => theme.palette.altBackground};
    content: '';
    display: inline-block;
    height: 20px;
    margin-${({ $reverseOrder }) => ($reverseOrder ? 'left' : 'right')}: ${({
  theme,
}) => theme.spacing.small};
    position: relative;
    top: 2px;
    visibility: visible;
    width: 20px;
  }
`;

export const StyledInput = styled.input`
  ${visibilityStyles};

  &:focus + label span,
  &:hover + label span {
    border-color: ${({ theme }) => theme.palette.brand};
    cursor: pointer;
  }

  &:focus + label span {
    ${focusStyles};
  }

  &:checked + label span:after {
    content: '';
    display: block;
    position: absolute;
    border: solid ${({ theme }) => theme.palette.black};
    border-left: solid ${({ theme }) => theme.palette.white};
    border-width: 0 2px 2px 0;
    height: 13px;
    left: 5px;
    top: 1px;
    transform: rotate(45deg);
    width: 6px;
    zoom: 1;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;
